<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-5" flat>
        <v-icon>mdi-format-align-justify</v-icon>
        <v-toolbar-title class="toolbar-title-3">{{labels.title}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex lg5 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="polPd" v-model="mainForm.polPd" :label="labels.polPd" :error-messages="errors.collect('polPd')" data-vv-name="polPd" :data-vv-as="labels.polPd" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg4 xs12>
            </v-flex>

            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="riskStamp" v-model="mainForm.riskStamp" :label="labels.riskStamp" :error-messages="errors.collect('riskStamp')" data-vv-name="riskStamp" :data-vv-as="labels.riskStamp" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg1 xs12>
              <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.polStampAE" readonly></v-checkbox>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="polStamp" v-model="mainForm.polStamp" :label="labels.polStamp" :error-messages="errors.collect('polStamp')" data-vv-name="polStamp" :data-vv-as="labels.polStamp" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg4 xs12>
            </v-flex>

            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="riskFee" v-model="mainForm.riskFee" :label="labels.riskFee" :error-messages="errors.collect('riskFee')" data-vv-name="riskFee" :data-vv-as="labels.riskFee" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg1 xs12>
              <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.polFeeAE" readonly></v-checkbox>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="polFee" v-model="mainForm.polFee" :label="labels.polFee" :error-messages="errors.collect('polFee')" data-vv-name="polFee" :data-vv-as="labels.polFee" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg4 xs12>
            </v-flex>

            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="riskTax" v-model="mainForm.riskTax" :label="labels.riskTax" :error-messages="errors.collect('riskTax')" data-vv-name="riskTax" :data-vv-as="labels.riskTax" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg1 xs12>
              <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.polTaxAE" readonly></v-checkbox>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="polTax" v-model="mainForm.polTax" :label="labels.polTax" :error-messages="errors.collect('polTax')" data-vv-name="polTax" :data-vv-as="labels.polTax" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg4 xs12>
            </v-flex>

            <v-flex lg4 xs12>
            </v-flex>
            <v-flex lg1 xs12>
              <v-text-field ref="discPer" v-model="mainForm.discPer" :label="labels.discPer" :error-messages="errors.collect('discPer')" data-vv-name="discPer" :data-vv-as="labels.discPer" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="disc" v-model="mainForm.disc" :label="labels.disc" :error-messages="errors.collect('disc')" data-vv-name="disc" :data-vv-as="labels.disc" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <!-- <v-text-field v-model="mainForm.gstPrem" :label="labels.gstPrem" :error-messages="errors.collect('gstPrem')" data-vv-name="gstPrem" :data-vv-as="labels.gstPrem" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field> -->
            </v-flex>

            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
            </v-flex>
            <v-flex lg1 xs12>
              <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstStatRateAEPrem" readonly></v-checkbox>
            </v-flex>
            <v-flex lg3 xs12>
              <v-autocomplete :label="labels.gstStatPrem" :items="gstStatList" v-model="mainForm.gstStatPrem" item-text="label" item-value="value"
              readonly></v-autocomplete>
            </v-flex>
            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="gstRatePrem" v-model="mainForm.gstRatePrem" :label="labels.gstRatePrem" :error-messages="errors.collect('gstRatePrem')" data-vv-name="gstRatePrem"
              :data-vv-as="labels.gstRatePrem" v-num-mask="{negative: false, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>

            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
            </v-flex>
            <v-flex lg1 xs12>
              <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstAEPrem" readonly></v-checkbox>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="gstPrem" v-model="mainForm.gstPrem" :label="labels.gstPrem" :error-messages="errors.collect('gstPrem')" data-vv-name="gstPrem"
              :data-vv-as="labels.gstPrem" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg4 xs12>
            </v-flex>

            <v-flex lg4 xs12>
              <v-text-field v-model="mainForm.acctName1" :label="labels.acctName1" :error-messages="errors.collect('acctName1')" data-vv-name="acctName1" :data-vv-as="labels.acctName1" readonly></v-text-field>
            </v-flex>
            <v-flex lg1 xs12>
              <v-text-field ref="comm1Per" v-model="mainForm.comm1Per" :label="labels.comm1Per" :error-messages="errors.collect('comm1Per')" data-vv-name="comm1Per" :data-vv-as="labels.comm1Per" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="comm1" v-model="mainForm.comm1" :label="labels.comm1" :error-messages="errors.collect('comm1')" data-vv-name="comm1" :data-vv-as="labels.comm1" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <!-- <v-text-field v-model="mainForm.gstComm1" :label="labels.gstComm1" :error-messages="errors.collect('gstComm1')" data-vv-name="gstComm1" :data-vv-as="labels.gstComm1" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field> -->
            </v-flex>

            <!-- GST Comm1 -->
            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
            </v-flex>
            <v-flex lg1 xs12>
              <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstStatRateAEComm1" readonly></v-checkbox>
            </v-flex>
            <v-flex lg3 xs12>
              <v-autocomplete :label="labels.gstStatComm1" :items="gstStatList" v-model="mainForm.gstStatComm1" item-text="label" item-value="value"
              readonly></v-autocomplete>
            </v-flex>
            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="gstRateComm1" v-model="mainForm.gstRateComm1" :label="labels.gstRateComm1" :error-messages="errors.collect('gstRateComm1')" data-vv-name="gstRateComm1"
              :data-vv-as="labels.gstRateComm1" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>

            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
            </v-flex>
            <v-flex lg1 xs12>
              <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstAEComm1" readonly></v-checkbox>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="gstComm1" v-model="mainForm.gstComm1" :label="labels.gstComm1" :error-messages="errors.collect('gstComm1')" data-vv-name="gstComm1"
              :data-vv-as="labels.gstComm1" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"
              ></v-text-field>
            </v-flex>
            <v-flex lg4 xs12>
            </v-flex>

            <v-flex lg5 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="totAfterComm1" v-model="mainForm.totAfterComm1" :label="labels.totAfterComm1" :error-messages="errors.collect('totAfterComm1')" data-vv-name="totAfterComm1" :data-vv-as="labels.totAfterComm1" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg4 xs12>
            </v-flex>

            <v-flex lg4 xs12>
              <v-text-field v-model="mainForm.acctName2" :label="labels.acctName2" :error-messages="errors.collect('acctName2')" data-vv-name="acctName2" :data-vv-as="labels.acctName2" readonly></v-text-field>
            </v-flex>
            <v-flex lg1 xs12>
              <v-text-field ref="comm2Per" v-model="mainForm.comm2Per" :label="labels.comm2Per" :error-messages="errors.collect('comm2Per')" data-vv-name="comm2Per" :data-vv-as="labels.comm2Per" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="comm2" v-model="mainForm.comm2" :label="labels.comm2" :error-messages="errors.collect('comm2')" data-vv-name="comm2" :data-vv-as="labels.comm2" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <!-- <v-text-field v-model="mainForm.gstComm2" :label="labels.gstComm2" :error-messages="errors.collect('gstComm2')" data-vv-name="gstComm2" :data-vv-as="labels.gstComm2" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field> -->
            </v-flex>

            <!-- GST Comm2 -->
            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
            </v-flex>
            <v-flex lg1 xs12>
              <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstStatRateAEComm2" readonly></v-checkbox>
            </v-flex>
            <v-flex lg3 xs12>
              <v-autocomplete :label="labels.gstStatComm2" :items="gstStatList" v-model="mainForm.gstStatComm2" item-text="label" item-value="value"
              readonly></v-autocomplete>
            </v-flex>
            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="gstRateComm2" v-model="mainForm.gstRateComm2" :label="labels.gstRateComm2" :error-messages="errors.collect('gstRateComm2')" data-vv-name="gstRateComm2"
              :data-vv-as="labels.gstRateComm2" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>

            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
            </v-flex>
            <v-flex lg1 xs12>
              <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstAEComm2" readonly></v-checkbox>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="gstComm2" v-model="mainForm.gstComm2" :label="labels.gstComm2" :error-messages="errors.collect('gstComm2')" data-vv-name="gstComm2"
              :data-vv-as="labels.gstComm2" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"
              ></v-text-field>
            </v-flex>
            <v-flex lg4 xs12>
            </v-flex>

            <v-flex lg5 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="totAfterComm2" v-model="mainForm.totAfterComm2" :label="labels.totAfterComm2" :error-messages="errors.collect('totAfterComm2')" data-vv-name="totAfterComm2" :data-vv-as="labels.totAfterComm2" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg4 xs12>
            </v-flex>

            <v-flex lg4 xs12>
              <v-text-field v-model="mainForm.acctName3" :label="labels.acctName3" :error-messages="errors.collect('acctName3')" data-vv-name="acctName3" :data-vv-as="labels.acctName3" readonly></v-text-field>
            </v-flex>
            <v-flex lg1 xs12>
              <v-text-field ref="comm3Per" v-model="mainForm.comm3Per" :label="labels.comm3Per" :error-messages="errors.collect('comm3Per')" data-vv-name="comm3Per" :data-vv-as="labels.comm3Per" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="comm3" v-model="mainForm.comm3" :label="labels.comm3" :error-messages="errors.collect('comm3')" data-vv-name="comm3" :data-vv-as="labels.comm3" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <!-- <v-text-field v-model="mainForm.gstComm3" :label="labels.gstComm3" :error-messages="errors.collect('gstComm3')" data-vv-name="gstComm3" :data-vv-as="labels.gstComm3" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field> -->
            </v-flex>

            <!-- GST Comm3 -->
            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
            </v-flex>
            <v-flex lg1 xs12>
              <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstStatRateAEComm3" readonly></v-checkbox>
            </v-flex>
            <v-flex lg3 xs12>
              <v-autocomplete :label="labels.gstStatComm3" :items="gstStatList" v-model="mainForm.gstStatComm3" item-text="label" item-value="value"
              readonly></v-autocomplete>
            </v-flex>
            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="gstRateComm3" v-model="mainForm.gstRateComm3" :label="labels.gstRateComm3" :error-messages="errors.collect('gstRateComm3')" data-vv-name="gstRateComm3"
              :data-vv-as="labels.gstRateComm3" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>

            <v-flex lg1 xs12>
            </v-flex>
            <v-flex lg3 xs12>
            </v-flex>
            <v-flex lg1 xs12>
              <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.gstAEComm3" readonly></v-checkbox>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="gstComm3" v-model="mainForm.gstComm3" :label="labels.gstComm3" :error-messages="errors.collect('gstComm3')" data-vv-name="gstComm3"
              :data-vv-as="labels.gstComm3" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"
              ></v-text-field>
            </v-flex>
            <v-flex lg4 xs12>
            </v-flex>

            <v-flex lg5 xs12>
            </v-flex>
            <v-flex lg3 xs12>
              <v-text-field ref="totAfterComm3" v-model="mainForm.totAfterComm3" :label="labels.totAfterComm3" :error-messages="errors.collect('totAfterComm3')" data-vv-name="totAfterComm3" :data-vv-as="labels.totAfterComm3" v-num-mask="{negative: true, intScale: 18, decScale: 2}" readonly reverse :loading="loading"></v-text-field>
            </v-flex>
            <v-flex lg4 xs12>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { removeFormatNumber } from '@/utils/number'
import { formatPrice } from '@/utils/index'
export default {
  data () {
    return {
      labels: {
        title: 'Policy Totals',
        polPd: 'Premium Due',
        riskStamp: 'Risk Stamp',
        polStamp: 'Policy Stamp',
        riskFee: 'Risk Fee',
        polFee: 'Policy Fee',
        riskTax: 'Risk Tax',
        polTax: 'Policy Tax',
        discPer: 'Discount %',
        disc: 'Discount Amount',
        gstPrem: 'GST - Premium',
        acctName1: 'Billing Account 1 Name',
        comm1Per: 'Comm 1 %',
        comm1: 'Commission 1',
        gstComm1: 'GST - Commission 1',
        totAfterComm1: 'Total after Commission 1',
        acctName2: 'Billing Account 2 Name',
        comm2Per: 'Comm 2 %',
        comm2: 'Commission 2',
        gstComm2: 'GST - Commission 2',
        totAfterComm2: 'Total after Commission 2',
        acctName3: 'Billing Account 3 Name',
        comm3Per: 'Comm 3 %',
        comm3: 'Commission 3',
        gstComm3: 'GST - Commission 3',
        totAfterComm3: 'Total after Commission 3'
      },
      mainForm: {
        polPd: undefined,
        riskStamp: undefined,
        polStampAE: undefined,
        polStamp: undefined,
        riskFee: undefined,
        polFeeAE: undefined,
        polFee: undefined,
        riskTax: undefined,
        polTaxAE: undefined,
        polTax: undefined,
        discPer: undefined,
        disc: undefined,
        gstPrem: undefined,
        acctName1: undefined,
        comm1Per: undefined,
        comm1: undefined,
        gstComm1: undefined,
        totAfterComm1: undefined,
        acctName2: undefined,
        comm2Per: undefined,
        comm2: undefined,
        gstComm2: undefined,
        totAfterComm2: undefined,
        acctName3: undefined,
        comm3Per: undefined,
        comm3: undefined,
        gstComm3: undefined,
        totAfterComm3: undefined,
        gstStatPrem: undefined,
        gstStatComm1: undefined,
        gstStatComm2: undefined,
        gstStatComm3: undefined,
        gstRatePrem: undefined,
        gstRateComm1: undefined,
        gstRateComm2: undefined,
        gstRateComm3: undefined,
        gstAEPrem: undefined,
        gstAEComm1: undefined,
        gstAEComm2: undefined,
        gstAEComm3: undefined,
        gstStatRateAEPrem: undefined,
        gstStatRateAEComm1: undefined,
        gstStatRateAEComm2: undefined,
        gstStatRateAEComm3: undefined,
        gstApp: undefined
      },
      perPolStp: undefined,
      perPolFee: undefined,
      perPolTax: undefined,
      loading: false,
      gstStatList: []
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    }
  },
  methods: {
    doInit() {
      this.labels.title = 'Policy Totals (' + this.polMaster.billCurr + ')'
      this.getGstStatList()
      this.getPolicyTotals()
    },
    async getGstStatList() {
      const apiUrl = this.$store.state.underwriting.policySummarySettings.menu.gstStatList
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          if (result.data) {
            const { data } = result.data
            if (data) {
              this.$set(this, 'gstStatList', data)
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getPolicyTotals() {
      const apiUrl = this.$store.state.underwriting.policySummarySettings.menu.queryPolicyTotals
      if (apiUrl) {
        try {
          this.loading = true

          const polStampAE = this.mainForm.polStampAE !== undefined ? this.mainForm.polStampAE : this.polMaster.polStampAE
          const polStamp = this.mainForm.polStamp !== undefined ? this.mainForm.polStamp : this.polMaster.polStamp
          const polFeeAE = this.mainForm.polFeeAE !== undefined ? this.mainForm.polFeeAE : this.polMaster.polFeeAE
          const polFee = this.mainForm.polFee !== undefined ? this.mainForm.polFee : this.polMaster.polFee
          const polTaxAE = this.mainForm.polTaxAE !== undefined ? this.mainForm.polTaxAE : this.polMaster.polTaxAE
          const polTax = this.mainForm.polTax !== undefined ? this.mainForm.polTax : this.polMaster.polTax
          const gstStatPrem = this.mainForm.gstStatPrem !== undefined ? this.mainForm.gstStatPrem : this.polMaster.gstStatPrem
          const gstStatComm1 = this.mainForm.gstStatComm1 !== undefined ? this.mainForm.gstStatComm1 : this.polMaster.gstStatComm1
          const gstStatComm2 = this.mainForm.gstStatComm2 !== undefined ? this.mainForm.gstStatComm2 : this.polMaster.gstStatComm2
          const gstStatComm3 = this.mainForm.gstStatComm3 !== undefined ? this.mainForm.gstStatComm3 : this.polMaster.gstStatComm3
          const gstRatePrem = this.mainForm.gstRatePrem !== undefined ? this.mainForm.gstRatePrem : this.polMaster.gstRatePrem
          const gstRateComm1 = this.mainForm.gstRateComm1 !== undefined ? this.mainForm.gstRateComm1 : this.polMaster.gstRateComm1
          const gstRateComm2 = this.mainForm.gstRateComm2 !== undefined ? this.mainForm.gstRateComm2 : this.polMaster.gstRateComm2
          const gstRateComm3 = this.mainForm.gstRateComm3 !== undefined ? this.mainForm.gstRateComm3 : this.polMaster.gstRateComm3
          const gstAEPrem = this.mainForm.gstAEPrem !== undefined ? this.mainForm.gstAEPrem : this.polMaster.gstAEPrem
          const gstAEComm1 = this.mainForm.gstAEComm1 !== undefined ? this.mainForm.gstAEComm1 : this.polMaster.gstAEComm1
          const gstAEComm2 = this.mainForm.gstAEComm2 !== undefined ? this.mainForm.gstAEComm2 : this.polMaster.gstAEComm2
          const gstAEComm3 = this.mainForm.gstAEComm3 !== undefined ? this.mainForm.gstAEComm3 : this.polMaster.gstAEComm3
          const gstPrem = this.mainForm.gstPrem !== undefined ? this.mainForm.gstPrem : this.polMaster.gstPrem
          const gstComm1 = this.mainForm.gstComm1 !== undefined ? this.mainForm.gstComm1 : this.polMaster.gstComm1
          const gstComm2 = this.mainForm.gstComm2 !== undefined ? this.mainForm.gstComm2 : this.polMaster.gstComm2
          const gstComm3 = this.mainForm.gstComm3 !== undefined ? this.mainForm.gstComm3 : this.polMaster.gstComm3
          const gstStatRateAEPrem = this.mainForm.gstStatRateAEPrem !== undefined ? this.mainForm.gstStatRateAEPrem : this.polMaster.gstStatRateAEPrem
          const gstStatRateAEComm1 = this.mainForm.gstStatRateAEComm1 !== undefined ? this.mainForm.gstStatRateAEComm1 : this.polMaster.gstStatRateAEComm1
          const gstStatRateAEComm2 = this.mainForm.gstStatRateAEComm2 !== undefined ? this.mainForm.gstStatRateAEComm2 : this.polMaster.gstStatRateAEComm2
          const gstStatRateAEComm3 = this.mainForm.gstStatRateAEComm3 !== undefined ? this.mainForm.gstStatRateAEComm3 : this.polMaster.gstStatRateAEComm3
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            polStampAE: polStampAE,
            polStamp: removeFormatNumber(polStamp),
            polFeeAE: polFeeAE,
            polFee: removeFormatNumber(polFee),
            polTaxAE: polTaxAE,
            polTax: removeFormatNumber(polTax),
            gstStatPrem: gstStatPrem,
            gstStatComm1: gstStatComm1,
            gstStatComm2: gstStatComm2,
            gstStatComm3: gstStatComm3,
            gstRatePrem: removeFormatNumber(gstRatePrem),
            gstRateComm1: removeFormatNumber(gstRateComm1),
            gstRateComm2: removeFormatNumber(gstRateComm2),
            gstRateComm3: removeFormatNumber(gstRateComm3),
            gstAEPrem: gstAEPrem,
            gstAEComm1: gstAEComm1,
            gstAEComm2: gstAEComm2,
            gstAEComm3: gstAEComm3,
            gstPrem: gstPrem,
            gstComm1: gstComm1,
            gstComm2: gstComm2,
            gstComm3: gstComm3,
            gstStatRateAEPrem: gstStatRateAEPrem,
            gstStatRateAEComm1: gstStatRateAEComm1,
            gstStatRateAEComm2: gstStatRateAEComm2,
            gstStatRateAEComm3: gstStatRateAEComm3
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          this.setPolicyTotals(result)
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    setPolicyTotals(result) {
      const { data } = result
      if (data) {
        this.perPolStp = data.perPolStp
        this.perPolFee = data.perPolFee
        this.perPolTax = data.perPolTax

        this.mainForm.polPd = formatPrice(data.polPd)
        this.mainForm.riskStamp = formatPrice(data.riskStamp)
        this.mainForm.polStampAE = data.polStampAE
        this.mainForm.polStamp = formatPrice(data.polStamp)
        this.mainForm.riskFee = formatPrice(data.riskFee)
        this.mainForm.polFeeAE = data.polFeeAE
        this.mainForm.polFee = formatPrice(data.polFee)
        this.mainForm.riskTax = formatPrice(data.riskTax)
        this.mainForm.polTaxAE = data.polTaxAE
        this.mainForm.polTax = formatPrice(data.polTax)
        this.mainForm.discPer = formatPrice(data.discPer)
        this.mainForm.disc = formatPrice(data.disc)
        this.mainForm.gstPrem = formatPrice(data.gstPrem)
        this.mainForm.acctName1 = data.acctName1
        this.mainForm.comm1Per = formatPrice(data.comm1Per)
        this.mainForm.comm1 = formatPrice(data.comm1)
        this.mainForm.gstComm1 = formatPrice(data.gstComm1)
        this.mainForm.totAfterComm1 = formatPrice(data.totAfterComm1)
        this.mainForm.acctName2 = data.acctName2
        this.mainForm.comm2Per = formatPrice(data.comm2Per)
        this.mainForm.comm2 = formatPrice(data.comm2)
        this.mainForm.gstComm2 = formatPrice(data.gstComm2)
        this.mainForm.totAfterComm2 = formatPrice(data.totAfterComm2)
        this.mainForm.acctName3 = data.acctName3
        this.mainForm.comm3Per = formatPrice(data.comm3Per)
        this.mainForm.comm3 = formatPrice(data.comm3)
        this.mainForm.gstComm3 = formatPrice(data.gstComm3)
        this.mainForm.totAfterComm3 = formatPrice(data.totAfterComm3)
        this.mainForm.gstStatPrem = data.gstStatPrem
        this.mainForm.gstStatComm1 = data.gstStatComm1
        this.mainForm.gstStatComm2 = data.gstStatComm2
        this.mainForm.gstStatComm3 = data.gstStatComm3
        this.mainForm.gstRatePrem = formatPrice(data.gstRatePrem)
        this.mainForm.gstRateComm1 = formatPrice(data.gstRateComm1)
        this.mainForm.gstRateComm2 = formatPrice(data.gstRateComm2)
        this.mainForm.gstRateComm3 = formatPrice(data.gstRateComm3)
        this.mainForm.gstAEPrem = data.gstAEPrem
        this.mainForm.gstAEComm1 = data.gstAEComm1
        this.mainForm.gstAEComm2 = data.gstAEComm2
        this.mainForm.gstAEComm3 = data.gstAEComm3
        this.mainForm.gstStatRateAEPrem = data.gstStatRateAEPrem
        this.mainForm.gstStatRateAEComm1 = data.gstStatRateAEComm1
        this.mainForm.gstStatRateAEComm2 = data.gstStatRateAEComm2
        this.mainForm.gstStatRateAEComm3 = data.gstStatRateAEComm3
        this.mainForm.gstApp = data.gstApp

        // 2020-12-22 LYT Fixed on blur to zero
        // this.$refs.polPd.$el.cleave.setRawValue(this.mainForm.polPd)
        // this.$refs.riskStamp.$el.cleave.setRawValue(this.mainForm.riskStamp)
        // this.$refs.polStamp.$el.cleave.setRawValue(this.mainForm.polStamp)
        // this.$refs.riskFee.$el.cleave.setRawValue(this.mainForm.riskFee)
        // this.$refs.polFee.$el.cleave.setRawValue(this.mainForm.polFee)
        // this.$refs.riskTax.$el.cleave.setRawValue(this.mainForm.riskTax)
        // this.$refs.polTax.$el.cleave.setRawValue(this.mainForm.polTax)
        // this.$refs.discPer.$el.cleave.setRawValue(this.mainForm.discPer)
        // this.$refs.disc.$el.cleave.setRawValue(this.mainForm.disc)
        // this.$refs.gstRatePrem.$el.cleave.setRawValue(this.mainForm.gstRatePrem)
        // this.$refs.gstPrem.$el.cleave.setRawValue(this.mainForm.gstPrem)
        // this.$refs.comm1Per.$el.cleave.setRawValue(this.mainForm.comm1Per)
        // this.$refs.comm1.$el.cleave.setRawValue(this.mainForm.comm1)
        // this.$refs.gstRateComm1.$el.cleave.setRawValue(this.mainForm.gstRateComm1)
        // this.$refs.gstComm1.$el.cleave.setRawValue(this.mainForm.gstComm1)
        // this.$refs.totAfterComm1.$el.cleave.setRawValue(this.mainForm.totAfterComm1)
        // this.$refs.comm2Per.$el.cleave.setRawValue(this.mainForm.comm2Per)
        // this.$refs.comm2.$el.cleave.setRawValue(this.mainForm.comm2)
        // this.$refs.gstRateComm2.$el.cleave.setRawValue(this.mainForm.gstRateComm2)
        // this.$refs.gstComm2.$el.cleave.setRawValue(this.mainForm.gstComm2)
        // this.$refs.totAfterComm2.$el.cleave.setRawValue(this.mainForm.totAfterComm2)
        // this.$refs.comm3Per.$el.cleave.setRawValue(this.mainForm.comm3Per)
        // this.$refs.comm3.$el.cleave.setRawValue(this.mainForm.comm3)
        // this.$refs.gstRateComm3.$el.cleave.setRawValue(this.mainForm.gstRateComm3)
        // this.$refs.gstComm3.$el.cleave.setRawValue(this.mainForm.gstComm3)
        // this.$refs.totAfterComm3.$el.cleave.setRawValue(this.mainForm.totAfterComm3)
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policySummarySettings.init === 1) {
      // this.doInit()
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
